import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let ViedocBox = class ViedocBox extends LitElement {
    render() {
        return html `
      <section>
        <slot></slot>
      </section>
    `;
    }
};
ViedocBox.styles = [
    css `
      section {
        font-family: var(--font-family-monument);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        border-radius: 30px;
        overflow: hidden;
      }

      section ::slotted(*:not(:last-child)) {
        border-bottom: solid 2px var(--primary-background-color);
      }
    `,
];
ViedocBox = __decorate([
    customElement('viedoc-box')
], ViedocBox);
export { ViedocBox };
